var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalOfferIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0575 8.685L9.3075 1.935C9.0375 1.665 8.6625 1.5 8.25 1.5H3C2.175 1.5 1.5 2.175 1.5 3V8.25C1.5 8.6625 1.665 9.0375 1.9425 9.315L8.6925 16.065C8.9625 16.335 9.3375 16.5 9.75 16.5C10.1625 16.5 10.5375 16.335 10.8075 16.0575L16.0575 10.8075C16.335 10.5375 16.5 10.1625 16.5 9.75C16.5 9.3375 16.3275 8.955 16.0575 8.685ZM4.125 5.25C3.5025 5.25 3 4.7475 3 4.125C3 3.5025 3.5025 3 4.125 3C4.7475 3 5.25 3.5025 5.25 4.125C5.25 4.7475 4.7475 5.25 4.125 5.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalOfferIc);
export default __webpack_public_path__ + "static/media/local_offer_ic.cd03033d862bf1f0dd109397be204a08.svg";
export { ForwardRef as ReactComponent };